// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__oMLma {
    display: flex;
    align-items: center;
    background: white;
    border-top: 1px solid #f2f2f2;
    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.14);
    overflow: hidden;
    transition: height 1.3s ease;
    font-size: 16px;
    line-height: 18px;
    padding: 5px 24px 5px 16px
}

.iconContainer__CPWun {
    font-size: 20px;
}

.messageContainer__q5B12 {
    flex-grow: 1;
    padding: 0 20px;
}

.actionsContainer__d8S7q { }

.ctaButton__WYuCL {
    margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/MarketingBanner/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,+CAA+C;IAC/C,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,2BAAoB;;AAEpB;IACI,iBAAiB;AACrB","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    background: white;\n    border-top: 1px solid #f2f2f2;\n    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.14);\n    overflow: hidden;\n    transition: height 1.3s ease;\n    font-size: 16px;\n    line-height: 18px;\n    padding: 5px 24px 5px 16px\n}\n\n.iconContainer {\n    font-size: 20px;\n}\n\n.messageContainer {\n    flex-grow: 1;\n    padding: 0 20px;\n}\n\n.actionsContainer { }\n\n.ctaButton {\n    margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__oMLma`,
	"iconContainer": `iconContainer__CPWun`,
	"messageContainer": `messageContainer__q5B12`,
	"actionsContainer": `actionsContainer__d8S7q`,
	"ctaButton": `ctaButton__WYuCL`
};
module.exports = ___CSS_LOADER_EXPORT___;
